import DateObject from 'react-date-object';
var createDateRange = function (_a) {
    var startDate = _a.startDate, stopDate = _a.stopDate;
    var dateArray = [];
    var start = new DateObject(startDate);
    var end = new DateObject(stopDate);
    while (start <= end) {
        dateArray.push(new DateObject(start).format('YYYY-MM-DD'));
        start = new DateObject(start).add(1, 'days');
    }
    return dateArray;
};
export default createDateRange;
//# sourceMappingURL=create-date-range.js.map